import { inPoly, polygons, courierMskZone } from './polygons'

export function isInPolygonMsk(object) {
  return inPoly(object, polygons.moscow.paths)
}

export function isInPolygonSpb(object) {
  return inPoly(object, polygons.piter.paths)
}

export function isInPolygonKiev(object) {
  return inPoly(object, polygons.kiev.paths)
}

export function getCourierMskZone(object) {
  return courierMskZone(object)
}
